import { forwardRef, Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { Store } from '@ngrx/store';
import { CustomerInfoLoadIfNormalUserGuard } from 'app/core/guards/customer-info-load-if-normal-user.guard';
import { DependencyTreeCanActivate } from 'app/core/guards/dependency-tree.guard';
import { GetDefinitionsGuard } from 'app/core/store/definitions/definitions.resolve';
import { AuthorizationGuard } from 'app/core/store/session/authorization/authorization.resolve';
import { logger } from 'app/core/util/logger';
import * as fromRoot from '..';
import { RootState } from '../';
import * as actions from './flows.actions';
import { getFirst$$ } from '../../util/util';
import { goAction } from '../router/router.actions';
import { FlowFilterValuesLoadGuard } from '../../guards/flow-filter-values-load.guard';

/**
 * Guard to synchronously clear orders filter & result
 */
@Injectable({ providedIn: 'root' })
export class FlowsFilterQueryGuard implements CanActivate, DependencyTreeCanActivate {
  private store: Store<fromRoot.RootState>;

  constructor(@Inject(forwardRef(() => Store)) store) {
    this.store = store;
  }

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    logger.debug(`In FlowsFilterQueryGuard`);
    const state = await getFirst$$<RootState>(this.store.select(state => state));
    if (!state.session.authorization.data.FLOW.QUERY) {
      this.store.dispatch(goAction({ path: '/' }));
      return false;
    }
    this.store.dispatch(new actions.FlowsSetFilterAction({ filter: { ...route.data.filter, customers: state.flows.filterValues.customerIds } }));
    this.store.dispatch(goAction({ path: '/flows/refresh' }));
    return false;
  }

  getDependencies(): any {
    return [CustomerInfoLoadIfNormalUserGuard, AuthorizationGuard, GetDefinitionsGuard, FlowFilterValuesLoadGuard];
  }

  getDependencyRouteData(): any {
    return {
      authorization: 'FLOW.QUERY',
    };
  }
}
